import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { OperationalAssurancesKPIDefinitionsPage } from 'src/app/model/page/group/operational-assurances/operational-assurances-kpi-definitions-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-operational-assurances-kpi-definitions-page',
  templateUrl: './operational-assurances-kpi-definitions-page.component.html',
  styleUrls: ['./operational-assurances-kpi-definitions-page.component.scss']
})
export class OperationalAssurancesKpiDefinitionsPageComponent implements OnInit {
  operationalAssurancesKPIDefinitionsPage: OperationalAssurancesKPIDefinitionsPage = {} as OperationalAssurancesKPIDefinitionsPage;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService, private httpClient: HttpClient) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'kpi-definition') {
        this.operationalAssurancesKPIDefinitionsPage.htmlTitle = title.htmlTitle;
      }
    });
    this.operationalAssurancesKPIDefinitionsPage.tableSection = [];

    const query = { 'fields.title': 'KPI Definitions' };
    this.contentfulService.getPageContentResponse(query).then((operationalAssurancesKPIDefinitionsPageEntries) => {
      this.mapBanner(operationalAssurancesKPIDefinitionsPageEntries.includes.Entry);
      this.sharedDataService.addSharedData(this.operationalAssurancesKPIDefinitionsPage.banner);
      this.mapTableSections(operationalAssurancesKPIDefinitionsPageEntries.includes.Entry);
      this.mapPageInfo(operationalAssurancesKPIDefinitionsPageEntries.items);
    });
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      this.operationalAssurancesKPIDefinitionsPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapBanner(operationalAssurancesKPIDefinitionsPageEntries: Entry<any>[]) {
    operationalAssurancesKPIDefinitionsPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.operationalAssurancesKPIDefinitionsPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url  as string
    };
  }

  private mapTableSections(operationalAssurancesNdcHealthCheckDashboardPageEntries: Entry<any>[]) {
    operationalAssurancesNdcHealthCheckDashboardPageEntries
      .filter((entry) => ModelValidator.isTableSection(entry))
      .forEach((entry) => {
        this.mapEntryToTableSection(entry);
      });
  }

  private mapEntryToTableSection(entry: Entry<any>) {
    this.operationalAssurancesKPIDefinitionsPage.tableSection.push({
      title: '',
      body: entry.fields['body'] as string,
      subBody: entry.fields['subBody'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      table: entry.fields['table'] as string
    });
    this.operationalAssurancesKPIDefinitionsPage.tableSection.sort((a, b) => a.order - b.order);
  }
}
